import urls from "../../constants/urls.js";
import axios from "axios";

const state = {
  liveRequests: [],
  loadingLiveRequests: false,
};

const getters = {
  getLiveRequests: (state) => state.liveRequests,
  getLoadingLiveRequests: (state) => state.loadingLiveRequests,
};

const mutations = {
  setLiveRequests(state, data) {
    state.liveRequests = data;
  },

  setLoadingLiveRequests(state, value) {
    state.loadingLiveRequests = value;
  },

  updateLiveRequest(state, updatedRequest) {
    const index = state.liveRequests.findIndex((req) => req.id === updatedRequest.id);
    if (index !== -1) {
      state.liveRequests.splice(index, 1, updatedRequest);
    }
  },
};

const actions = {
  getLiveRequests({ commit }) {
    commit("setLoadingLiveRequests", true);

    let orgId = localStorage.getItem("orgId");
    return axios
      .get(urls.liveRequests(orgId))
      .then((response) => {
        let liveRequestsData = Array.isArray(response.data) ? response.data : [];
        // Sort by updated_at in descending order (most recent first)
        liveRequestsData.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        commit("setLiveRequests", liveRequestsData);
        commit("setLoadingLiveRequests", false);
        return liveRequestsData;
      })
      .catch((e) => {
        console.log(e);
        commit("setLiveRequests", []);
        commit("setLoadingLiveRequests", false);
        return [];
      });
  },

  resubmitLiveRequest({ commit }, { campaignId, requestId, message }) {
    let orgId = localStorage.getItem("orgId");
    return axios
      .put(urls.liveRequestResubmit(orgId, campaignId, requestId), null, {
        params: { message },
      })
      .then((response) => {
        if (response.data) {
          commit("updateLiveRequest", response.data);
        }
        return true;
      })
      .catch((error) => {
        console.error("Live request resubmit error:", error);

        // Parse structured error response
        if (error.response && error.response.data) {
          const errorData = error.response.data;

          // Check if it's the structured error format with errors array
          if (errorData.status === "error" && errorData.errors && Array.isArray(errorData.errors)) {
            throw errorData;
          }

          // Handle other error formats
          if (errorData.message) {
            throw { message: errorData.message };
          }
        }

        // Handle network or other errors
        if (error.message) {
          throw { message: error.message };
        }

        // Fallback error
        throw { message: "An error occurred while submitting your request. Please try again." };
      });
  },

  submitLiveRequest({ dispatch }, { campaignId, message }) {
    let orgId = localStorage.getItem("orgId");
    return axios
      .post(urls.liveRequest.replace(":oid", orgId).replace(":cid", campaignId), null, {
        params: { message },
      })
      .then((response) => {
        // Refresh live requests to show the new request
        dispatch("getLiveRequests");
        return true;
      })
      .catch((error) => {
        console.error("Live request submit error:", error);

        // Parse structured error response
        if (error.response && error.response.data) {
          const errorData = error.response.data;

          // Check if it's the structured error format with errors array
          if (errorData.status === "error" && errorData.errors && Array.isArray(errorData.errors)) {
            throw errorData;
          }

          // Handle other error formats
          if (errorData.message) {
            throw { message: errorData.message };
          }
        }

        // Handle network or other errors
        if (error.message) {
          throw { message: error.message };
        }

        // Fallback error
        throw { message: "An error occurred while submitting your request. Please try again." };
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
